import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'
import { useRoute } from 'vue-router/composables'
import UserAlert from '@/widgets/Header/ui/UserAlert.vue'
import { userApi, UserNotification } from '@/enitites/user'
import { useImage } from '@/shared/composables/image'
import { getPluralString } from '@/services/pluralization'
import { HeaderLogoutButton } from '@/features/authorization'
import NotificationItem from '@/features/notifications/ui/NotificationItem.vue'
import { mdiCheck } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'TheHeader',
  setup(__props) {

const route = useRoute()
const { getAvatar } = useImage()
const getAlertToastMessage = computed(() => store.getters.getAlertToastMessage)
const getUserDB = computed(() => store.getters.getUserDB)

const scrolled = ref(window.scrollY)
const scrollPrev = ref(0)
const isShowMenu = ref(false)
const isShowUserAlert = ref(false)
const showNotificationMenu = ref(false)
const headerClass = ref('header')
const alertClass = ref('header__check-in-alert')
const notifications = ref<UserNotification[]>([])
const documentEl = document.documentElement

const isSignupRoute = computed(() => route.name === 'Signup' && store.getters.getUserDB)
const isEventCreateRoute = computed(() => route.name === 'CreateEventProcessing' && store.state.isCreateEventFlow)
const isHomePage = computed(() => route.name === 'Home')
const notificationsCount = computed(() => notifications.value.length)
const isWhiteHeader = computed(() => (isHomePage.value && scrolled.value > 151) || !isHomePage.value)
const getUserNotifications = async () => {
  if (!store.getters.getUserDB) return
  const data = await userApi.getNotifications()
  if (Array.isArray(data)) notifications.value = data
  else notifications.value = []
}

const readUserNotification = async (notification: UserNotification) => {
  showNotificationMenu.value = false
  await userApi.readNotification(notification.id)
  notifications.value = notifications.value.filter((n) => n.id !== notification.id)
}

const toggleNotificationMenu = () => {
  showNotificationMenu.value = !showNotificationMenu.value
  isShowUserAlert.value = false
  isShowMenu.value = false
  documentEl.classList.remove('no-scroll')
}

const toggleUserAlert = () => {
  isShowUserAlert.value = !isShowUserAlert.value
  isShowMenu.value = false
  showNotificationMenu.value = false
  documentEl.classList.remove('no-scroll')
}

const toggleMenu = () => {
  isShowMenu.value = !isShowMenu.value
  documentEl.classList.toggle('no-scroll')
  isShowUserAlert.value = false
  showNotificationMenu.value = false
}

const closeMenuAndUserAlert = () => {
  isShowMenu.value = false
  isShowUserAlert.value = false
}

const getHeaderClass = () => {
  if (isHomePage.value && scrolled.value < 151) return 'header header--up-page'
  if (isHomePage.value && scrolled.value >= 151 && scrolled.value > scrollPrev.value) return 'header header--up'
  if (!isHomePage.value && scrolled.value > 50 && scrolled.value > scrollPrev.value) return 'header header--up'
  return 'header'
}

const getAlertClass = () => {
  if (isHomePage.value && scrolled.value < 151) return 'header__check-in-alert--top'
  if (isHomePage.value && scrolled.value >= 151 && scrolled.value > scrollPrev.value)
    return 'header__check-in-alert--top'
  if (!isHomePage.value && scrolled.value > 50 && scrolled.value > scrollPrev.value)
    return 'header__check-in-alert--top'
  return 'header__check-in-alert'
}

const handlerChangeHeader = () => {
  scrolled.value = window.scrollY
  headerClass.value = getHeaderClass()
  alertClass.value = getAlertClass()
  scrollPrev.value = scrolled.value
}

watch(isHomePage, () => {
  handlerChangeHeader()
})

watch(
  () => route.name,
  () => {
    getUserNotifications()
    closeMenuAndUserAlert()
    documentEl.classList.remove('no-scroll')
  }
)

onMounted(async () => {
  await getUserNotifications()
  handlerChangeHeader()
  document.addEventListener('scroll', handlerChangeHeader)
  document.addEventListener('scroll', () => {
    if (isShowUserAlert.value) isShowUserAlert.value = false
    if (showNotificationMenu.value) showNotificationMenu.value = false
  })
})

return { __sfc: true,route, getAvatar, getAlertToastMessage, getUserDB, scrolled, scrollPrev, isShowMenu, isShowUserAlert, showNotificationMenu, headerClass, alertClass, notifications, documentEl, isSignupRoute, isEventCreateRoute, isHomePage, notificationsCount, isWhiteHeader, getUserNotifications, readUserNotification, toggleNotificationMenu, toggleUserAlert, toggleMenu, closeMenuAndUserAlert, getHeaderClass, getAlertClass, handlerChangeHeader, UserAlert, getPluralString, HeaderLogoutButton, NotificationItem, mdiCheck }
}

})